import { Component, Input } from '@angular/core';

@Component({
    selector: 'apc-action-card',
    templateUrl: './apc-action-card.component.html',
    styleUrls: ['./apc-action-card.component.scss'],
    standalone: false
})
export class ApcActionCardComponent {
  @Input() public titleIsUpperCase: boolean = false;
  @Input() public headerCursorPointer: boolean = false;
  @Input() public showIcon: boolean = true;
  @Input() public hideCardCss: boolean = false;
}
